import {
  Field,
  ImageField,
  LinkField,
  Image,
  Text,
  Link,
} from '@sitecore-jss/sitecore-jss-nextjs';
import { StyleguideComponentProps } from 'lib/component-props';
import { JSX } from 'react';

type DescriptionLinkItem = {
  id: string;
  fields: {
    link: LinkField;
    Title: Field<string>;
  };
};

type LPFooterProps = StyleguideComponentProps & {
  fields: {
    Background: any;
    Logo1: ImageField;
    'Logo1 Alignment': {
      displayName?: string;
      fields?: any;
    };
    Logo2?: ImageField;
    Logo3?: ImageField;
    FooterDescription: Field<string>;
    DescriptionLinks: DescriptionLinkItem[];
    DescriptionAlignment: {
      displayName: string;
      fields: any;
    };
  };
};

const LpFooter = (props: LPFooterProps): JSX.Element => {
  const { fields } = props;
  const {
    Logo1,
    Logo2,
    Logo3,
    FooterDescription,
    DescriptionLinks,
    DescriptionAlignment,
  } = fields;

  //const bgClass = fields?.Background?.name?.toLowerCase() || '';
  const logo1Align =
    fields['Logo1 Alignment']?.displayName?.toLowerCase() ||
    fields['Logo1 Alignment']?.displayName?.toLowerCase() ||
    'center';

  const hasLogo1 = !!Logo1?.value?.src;
  const hasLogo2 = !!Logo2?.value?.src;
  const hasLogo3 = !!Logo3?.value?.src;
  const hasMultipleLogos = hasLogo2 || hasLogo3;
  const logoAlignmentClass = hasMultipleLogos ? 'center' : logo1Align;

  const descAlign = DescriptionAlignment?.displayName?.toLowerCase() || 'left';

  return (
    <footer
      className={`lp-footer ${descAlign === 'right' ? 'desc-right' : ''}`}
      style={{
        background: `var(--color-${fields?.Background?.name?.toLowerCase()})`,
      }}
      id={`lp-footer-${props.rendering?.uid}`}
    >
      <div className={`footer-logos align-${logoAlignmentClass}`}>
        {hasLogo1 && <Image field={Logo1} className="footer-logo logo1" />}
        {hasLogo2 && <Image field={Logo2} className="footer-logo logo2" />}
        {hasLogo3 && <Image field={Logo3} className="footer-logo logo3" />}
      </div>

      <div className={`footer-description align-${descAlign}`}>
        {FooterDescription?.value && (
          <Text
            className="footer-description-text"
            field={FooterDescription}
            tag="div"
          />
        )}

        {DescriptionLinks?.length > 0 && (
          <ul className="footer-description-links">
            {DescriptionLinks.map(({ id, fields }) => (
              <li key={id}>
                <Link
                  field={fields?.link}
                  rel="noopener noreferrer"
                  target="_blank"
                >
                  {fields?.Title?.value}
                </Link>
              </li>
            ))}
          </ul>
        )}
      </div>
    </footer>
  );
};

export default LpFooter;
